<div class="container">
  <nav class="row fixed-top dateretrievedstyle">
    @if (totalSuccessCount > 0 || totalFailCount > 0) {
      <div class="alert alert-info"
        >
        @if (totalSuccessCount > 0) {
          <strong
            >{{ totalSuccessCount }} MedicationRequest(s) submitted Successfully.
          </strong>
        }
        @if (totalFailCount > 0) {
          <strong
            >{{ totalFailCount }} MedicationRequest(s) failed to Submit
          </strong>
        }
      </div>
    }
    <div class="col-md-6 date-label">
      <strong>Date Retrieved </strong> : {{ now | date : "yyyy-MM-dd HH:mm" }}
    </div>
  </nav>
  <div class="fixed_header">
    <table class="table table-striped margintop20">
      <thead>
        <tr>
          <th>Medication Request</th>
          <th>Authored On</th>
          <th>Start</th>
          <th>End</th>
          <th>
            <input
              type="checkbox"
              [(ngModel)]="isAllSelected"
              (ngModelChange)="selectAll()"
              [disabled]="isAlldisabled"
              />
          </th>
        </tr>
      </thead>
      <tbody>
        @for (entry of payload; track entry) {
          <tr [style.fontWeight]="entry.state" class="fontDMSans">
            <td>{{ entry.medicationDisplay }}</td>
            <td>
              {{ entry.authoredOn }}
            </td>
            <td>
              {{ entry.startDate }}
            </td>
            <td>{{ entry.endDate }}</td>
            <td>
              <input
                type="checkbox"
                [(ngModel)]="entry.selected"
                (ngModelChange)="toggleOption()"
                [disabled]="entry.state == 'lighter'"
                />
            </td>
          </tr>
        }
      </tbody>
    </table>
  </div>
</div>
<div class="row top-buffer float-end">
  <button
    type="button"
    class="btn btn-primary submit-btn"
    (click)="submitToCibmtr()"
    enabled
    >
    Submit to CIBMTR
  </button>
</div>
